import { OBJECT_LIST_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const ObjectLists = ObjectDefinitionRecord({
  objectTypeId: OBJECT_LIST_TYPE_ID,
  referenceObjectType: 'LIST_PROPERTIES'
});
export default ObjectLists;